import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { RATIO, TYPOGRAPHY_SIZE } from 'mm-theme-configuration/dist/consts';
import { useTheme } from '../../../../theming/useTheme';
import { MandatoryAdditionalStyle } from '../../../components.utils';
import { SemanticTagThemeProps, getStyleBySize } from '../../../../typography/semanticTags/semanticTags.utils';
import { BaseUnit } from '../../../../theming/baseUnitDefinition';

const componentConfigThemeKey = 'imageWithFigcaptionWrapper';

export const getStyle = (aspectRatio: RATIO, baseUnit: BaseUnit, figcaptionTextColor: string, backgroundColor: string) => StyleSheet.create({
  base: {
    backgroundColor,
    position: 'relative',
    overflow: 'hidden',
    margin: 0,
    boxSizing: 'border-box',
    flex: '1 1 100%',
    minWidth: '0%',
    paddingTop: `calc(100% / (${aspectRatio.x / aspectRatio.y}))`,
  },
  figcaption: {
    color: figcaptionTextColor,
    margin: `${baseUnit * 0.25}px`,
  },
});

interface ImageWrapperDataProps {
  aspectRatio: RATIO;
  figcaption: string;
  dataId?: string;
}

type ImageWithFigcaptionWrapperProps = ImageWrapperDataProps & MandatoryAdditionalStyle;

interface ImageWithFigcaptionWrapperThemeProps extends SemanticTagThemeProps {
  baseUnit: BaseUnit;
  figcaptionTextColor: string;
  backgroundColor: string;
}

type ImageWithFigcaptionWrapperComponentProps = ImageWithFigcaptionWrapperProps;

export const ImageWithFigcaptionWrapper: React.FunctionComponent<ImageWithFigcaptionWrapperComponentProps> = ({ additionalStyle, aspectRatio, figcaption, dataId, children }) => {
  const { fontSizesStyles, baseUnit, figcaptionTextColor, backgroundColor } = useTheme<ImageWithFigcaptionWrapperThemeProps>(componentConfigThemeKey);
  const imageWrapperStyle = getStyle(aspectRatio, baseUnit, figcaptionTextColor, backgroundColor);
  const figcaptionText = getStyleBySize(fontSizesStyles, { fontSizeSmall: TYPOGRAPHY_SIZE.NORMAL, fontSizeMedium: TYPOGRAPHY_SIZE.NORMAL, fontSizeLarge: TYPOGRAPHY_SIZE.NORMAL });
  return (
    <figure data-id={dataId} className={css(additionalStyle.style)}>
      <div className={css(imageWrapperStyle.base)}>
        {children}
      </div>
      <figcaption className={css(figcaptionText, imageWrapperStyle.figcaption)}>{figcaption}</figcaption>
    </figure>
  );
};
